module.exports = ".footer{background-color:#042E60}\n"